﻿import {IErrorInformation} from './errorInformation.model';

export interface IErrorRedirectService {
    redirectToErrorState(errorData: IErrorInformation): void;
    setErrorStateName(errorStateName: string): void;
}

export class ErrorRedirectService implements IErrorRedirectService {
    private errorStateName: string;

    static $inject = ['$state', '$rootScope', '$log'];
    constructor(private $state: angular.ui.IStateService,
        private $rootscope: angular.IRootScopeService,
        private $log: angular.ILogService) {
        this.$rootscope.$on('errorRedirect', this.onErrorRedirect);
    }

    public setErrorStateName(errorStateName: string): void {
        this.errorStateName = errorStateName;
    }

    public redirectToErrorState(errorData: IErrorInformation): void {
        if (!this.errorStateName) {
            this.$log.error("ErrorRedirectService:  cannot redirect to an error page, because no error state was configured.  Make sure to call setErrorStateName with a valid ui-router state name at application init.");
            return;
        }

        this.$state.go(this.errorStateName, { errorInformation: errorData });
    }

    private onErrorRedirect = (event: angular.IAngularEvent, errorData: IErrorInformation): void => {
        this.redirectToErrorState(errorData);
    }
}